export default {"src":"/_next/static/media/select-duration.67337fc0.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};